import { useState } from "react";
import { PageHero } from "../components/Layout";
import { ProjectGrid } from "../components/ProjectGrid";
import { CollabCTA } from "../components/CollabCTA";
import { useSite } from "../context/SiteContext";
import { FILTERS, matchesFilter } from "../lib/api";
import { useSeo } from "../lib/useSeo";

export default function Portfolio() {
  useSeo("Portfolio — Beauty, Makeup & Jewellery Visuals", "A curated portfolio of makeup product photography, jewellery advertisement visuals and luxury product video ads by BWI.");
  const { projects, loaded } = useSite();
  const [filter, setFilter] = useState(FILTERS[0]);
  const list = projects.filter((p) => matchesFilter(p, filter));

  return (
    <>
      <PageHero
        eyebrow="Portfolio"
        testid="portfolio-title"
        title={<>A Collection of <span className="italic">Intentional Creations.</span></>}
        text="A curated selection of beauty, makeup and jewellery visuals created with attention to every detail."
      />
      <section className="mx-auto max-w-[1400px] px-6 pb-28 md:px-10 md:pb-40">
        <div className="-mx-6 mb-16 overflow-x-auto px-6 md:mx-0 md:px-0" data-testid="portfolio-filters">
          <div className="flex w-max gap-2 border-b border-line md:w-auto md:flex-wrap">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
                aria-pressed={filter === f}
                className={`-mb-px whitespace-nowrap border-b px-4 py-4 text-[0.72rem] uppercase tracking-[0.2em] transition-colors duration-300 ${
                  filter === f ? "border-wine text-wine" : "border-transparent text-muted-ink hover:text-wine"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>
        {list.length ? (
          <ProjectGrid key={filter} projects={list} testid="portfolio-grid" />
        ) : (
          <p data-testid="portfolio-empty" className="py-24 text-center font-serif text-3xl italic text-wine/80">
            {loaded ? "New work in this category is on its way." : "Loading the collection…"}
          </p>
        )}
      </section>
      <CollabCTA />
    </>
  );
}
